import { v4 as uuidv4 } from 'uuid';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

// Get or create session ID
function getSessionId(): string {
  let sessionId = sessionStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = uuidv4();
    sessionStorage.setItem('sessionId', sessionId);
  }
  return sessionId;
}

// Detect device type
function getDeviceType(): string {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet';
  }
  if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return 'mobile';
  }
  return 'desktop';
}

// Detect browser
function getBrowser(): string {
  const ua = navigator.userAgent;
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Chrome')) return 'Chrome';
  if (ua.includes('Safari')) return 'Safari';
  if (ua.includes('Edge')) return 'Edge';
  return 'Other';
}

// Detect OS
function getOS(): string {
  const ua = navigator.userAgent;
  if (ua.includes('Win')) return 'Windows';
  if (ua.includes('Mac')) return 'macOS';
  if (ua.includes('Linux')) return 'Linux';
  if (ua.includes('Android')) return 'Android';
  if (ua.includes('iOS')) return 'iOS';
  return 'Other';
}

// Track page view
export async function trackPageView(page: string) {
  try {
    const token = localStorage.getItem('token');

    await fetch(`${API_URL}/api/track/pageview`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
      },
      // allow the browser to finish this request during unload/navigation
      keepalive: true,
      body: JSON.stringify({
        sessionId: getSessionId(),
        page,
        referrer: document.referrer,
        device: getDeviceType(),
        browser: getBrowser(),
        os: getOS(),
      }),
    });
  } catch (error) {
    console.error('Failed to track page view:', error);
  }
}

// Track page duration
export function trackPageDuration(page: string, startTime: number) {
  const duration = Math.floor((Date.now() - startTime) / 1000);

  // Send duration on page unload
  try {
    const payload = JSON.stringify({
      sessionId: getSessionId(),
      page,
      device: getDeviceType(),
      browser: getBrowser(),
      os: getOS(),
      duration,
    });

    if (navigator.sendBeacon) {
      // use a Blob with correct MIME type for better compatibility
      const blob = new Blob([payload], { type: 'application/json' });
      navigator.sendBeacon(`${API_URL}/api/track/pageview`, blob);
    } else {
      // fallback to fetch with keepalive
      fetch(`${API_URL}/api/track/pageview`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
      }).catch(() => {
        // ignore errors on unload
      });
    }
  } catch (e) {
    // swallow errors - analytics must not block unload
  }
}